import { createContext } from "react";
var IsDarkModeContext = /*#__PURE__*/createContext(false);
export default IsDarkModeContext;